import _ from 'lodash';
import { emailRe, passwordInputRe, passwordRe, strongPasswordRe } from './regex';
import { personalEmails } from '../constant/personalEmails';
export function validateName(vm, value) {
    value = _.trim(value);
    const length = _.size(value);
    if (length === 0) {
        return;
    }
    if (length > 128) {
        const message = vm.$t('nameLengthError');
        return message;
    }
    // 1. 特殊字符检查
    const hasError = /@/.test(value);
    // 2.是不是都是数字
    const match = value.match(/[0-9]+/);
    let allNumber = false;
    if (match && match.length === 1) {
        if (match[0] === value) {
            allNumber = true;
        }
    }
    if (hasError || allNumber) {
        const message = vm.$t('nameError');
        return message;
    }
}
export function validatePwd(vm, value, strongPwd) {
    const length = _.size(value);
    if (length === 0) {
        return;
    }
    if (strongPwd) {
        if (!strongPasswordRe.test(value)) {
            return vm.$t('commonSecurity.passwordNotIrr');
        }
    }
    else {
        if (!passwordRe.test(value)) {
            return vm.$t('commonSecurity.passwordNotIrr');
        }
    }
}
export function validatePwdCorrect(value, strongPwd) {
    if (strongPwd) {
        return strongPasswordRe.test(value);
    }
    else {
        return passwordRe.test(value);
    }
}
export function validateLoginPwd(vm, value) {
    const length = _.size(value);
    if (length === 0) {
        return '';
    }
    if (!passwordInputRe.test(value)) {
        return vm.$t('passport.pwdEnterInvalidCharacters');
    }
    return '';
}
export function validateBusinessEmail(vm, value, callback) {
    const isPersonalEmail = _.find(personalEmails, f => {
        return _.includes(value, f);
    });
    if (isPersonalEmail) {
        const message = vm.$t('passport.register.pleaseUseBusinessEmail');
        return callback(new Error(message));
    }
    return callback();
}
export function validateEmail(vm, value, callback) {
    value = _.trim(value);
    const length = _.size(value);
    if (length === 0) {
        return callback();
    }
    if (!emailRe.test(value)) {
        const message = vm.$t('passport.emailError');
        return callback(new Error(message));
    }
    return callback();
}
